// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {
    useEffect,
    useCallback,
    useContext,
} from 'react';
import {FIELD_KIND} from '@pub/shared/constants.js';
import {Select} from '@pub/comp/select.js';
import {Form_disabled_ctx} from './contexts.js';
import {use_controls, use_value} from './hooks.js';
import {Item} from './item.js';
import './form.less';

export function Dropdown({
    title,
    hint,
    field,
    required,
    disabled: dis,
    auto_focus,
    ...input_props
})
{
    const disabled_inner = useContext(Form_disabled_ctx);
    const {change_value, push_meta, remove_fields} = use_controls();
    const handle_change = useCallback(({value})=>{
        change_value(field, value);
    }, [field, change_value]);
    useEffect(()=>{
        push_meta(field, {
            required,
            kind: FIELD_KIND.TEXT,
        });
    }, [required]);
    useEffect(()=>()=>remove_fields([field]), [field]);
    const disabled = dis || disabled_inner;
    const val = use_value(field);
    return <Item title={title} hint={hint} required={required}>
      <Select className="sdk-form-input" value={val}
        auto_focus={auto_focus} on_change={handle_change} {...input_props}
        disabled={disabled}/>
    </Item>;
}
